/**
 * What SystemDox caches about the signed-in person, and drops at sign-out.
 *
 * Amplify clears its own tokens; nothing clears ours. On a shared machine the
 * next person at the keyboard would otherwise inherit the capture workflow
 * state — voice transcripts in progress — and every plan-history entry.
 */

const SESSION_KEYS = ['sdx_capture_workflow_state'];
const LOCAL_PREFIXES = ['plan-history:'];

/** Drop everything SystemDox remembered about the person who just signed out. */
export function clearSessionResidue(): void {
  try {
    for (const key of SESSION_KEYS) {
      localStorage.removeItem(key);
      sessionStorage.removeItem(key);
    }
    const doomed: string[] = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && LOCAL_PREFIXES.some((p) => key.startsWith(p))) doomed.push(key);
    }
    doomed.forEach((key) => localStorage.removeItem(key));
  } catch {
    // Storage unavailable: there was nothing to inherit.
  }
}
